import script from "./AppHero.vue?vue&type=script&setup=true&lang=js"
export * from "./AppHero.vue?vue&type=script&setup=true&lang=js"

import "./AppHero.vue?vue&type=style&index=0&id=23e4ecf4&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-23e4ecf4"]])

export default __exports__